import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MobileScreenShareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mobile_screen_share"}/>
}
